export const semanticPalette = {
  Success: {
    White: '#ffffff',
    S95: '#DCF7E1',
    S90: '#b9eec2',
    S80: '#75D78D',
    S70: '#28bc5e',
    S60: '#139948', // Main
    S50: '#137738',
    S40: '#005725',
    S30: '#033816'
  },
  Danger: {
    White: '#ffffff',
    S95: '#FCEAE6',
    S90: '#fed2cb',
    S80: '#fda293',
    S70: '#fe6652',
    S60: '#de3e2d', // Main
    S50: '#b32517',
    S40: '#861309',
    S30: '#590915'
  },
  Warning: {
    White: '#ffffff',
    S95: '#fcecd9',
    S90: '#fdd7ac',
    S80: '#fea92f', // Main
    S70: '#d98b09',
    S60: '#ad721c',
    S50: '#875814',
    S40: '#633f0c',
    S30: '#412805'
  },
  Info: {
    White: '#ffffff',
    S95: '#e3f1fb',
    S90: '#c1e3fc',
    S80: '#78c7fd',
    S70: '#02a9f7', // Main
    S60: '#0b89c8',
    S50: '#0e6a9b',
    S40: '#034d73',
    S30: '#0a3149'
  },
  Reduced: {
    White: '#FFFFFF',
    S95: '#EEEEEE',
    S90: '#DEDEDE',
    S80: '#BEBEBE',
    S70: '#9E9E9E', // Main
    S60: '#808080',
    S50: '#636363',
    S40: '#484848',
    S30: '#2E2E2E'
  }
}

export const secondaryPalette = {
  '20': {
    white: '#FFFFFF',
    C95: '#FCEAE9',
    C90: '#FED2D0',
    C80: '#FDA1A0',
    C70: '#F66B71',
    C60: '#CE5057',
    C50: '#A43A41',
    C40: '#7B252B',
    C30: '#442323'
  },
  '50': {
    white: '#FFFFFF',
    C95: '#FAEBE3',
    C90: '#FBD5C1',
    C80: '#F7A97C',
    C70: '#E77F3E',
    C60: '#C06325',
    C50: '#984B16',
    C40: '#713408',
    C30: '#422616'
  },
  '80': {
    white: '#FFFFFF',
    C95: '#F6EDE0',
    C90: '#F0DBB9',
    C80: '#E3B667',
    C70: '#CB9317',
    C60: '#A57710',
    C50: '#815C0A',
    C40: '#5E4205',
    C30: '#3B2B0D'
  },
  '110': {
    white: '#FFFFFF',
    C95: '#EFF0E1',
    C90: '#DFE2BC',
    C80: '#C2C46E',
    C70: '#A5A50E',
    C60: '#868604',
    C50: '#676815',
    C40: '#4B4B0D',
    C30: '#2F300F'
  },
  '140': {
    white: '#FFFFFF',
    C95: '#E8F2E5',
    C90: '#CDE7C7',
    C80: '#98CF8B',
    C70: '#63B650',
    C60: '#4E943E',
    C50: '#3E7232',
    C40: '#2B5322',
    C30: '#20341B'
  },
  '170': {
    white: '#FFFFFF',
    C95: '#E2F3EC',
    C90: '#BEE9D9',
    C80: '#6CD5B3',
    C70: '#17B991',
    C60: '#139676',
    C50: '#0F745B',
    C40: '#0B5441',
    C30: '#0D362A'
  },
  '200': {
    white: '#FFFFFF',
    C95: '#E0F3F4',
    C90: '#B8E9EB',
    C80: '#64D1D7',
    C70: '#09B4BB',
    C60: '#0D9298',
    C50: '#007176',
    C40: '#005256',
    C30: '#023538'
  },
  '230': {
    white: '#FFFFFF',
    C95: '#E2F1FA',
    C90: '#BDE5F9',
    C80: '#6BCBF7',
    C70: '#0BADE3',
    C60: '#088CB9',
    C50: '#026D91',
    C40: '#024F6A',
    C30: '#0D3242'
  },
  '260': {
    white: '#FFFFFF',
    C95: '#E7EFFC',
    C90: '#CBDFFF',
    C80: '#98BFFE',
    C70: '#639DFE',
    C60: '#4E7FD0',
    C50: '#3C62A1',
    C40: '#294778',
    C30: '#1F2E47'
  },
  '290': {
    white: '#FFFFFF',
    C95: '#EEEDFB',
    C90: '#DDD9FE',
    C80: '#BCB2FF',
    C70: '#9E8BF7',
    C60: '#8070CA',
    C50: '#63579D',
    C40: '#483E74',
    C30: '#2D2945'
  },
  '320': {
    white: '#FFFFFF',
    C95: '#F5EAF7',
    C90: '#EDD4F3',
    C80: '#DDA7EA',
    C70: '#C87CDA',
    C60: '#A363B2',
    C50: '#7E4D8A',
    C40: '#5D3666',
    C30: '#39253D'
  },
  '350': {
    white: '#FFFFFF',
    C95: '#FAE9F0',
    C90: '#F9D1E3',
    C80: '#F4A0C8',
    C70: '#E472AC',
    C60: '#BA5B8B',
    C50: '#90466C',
    C40: '#6B314E',
    C30: '#412331'
  }
}

export const brandPalette = {
  Blue: {
    Blue80: '#98bffe',
    Blue70: '#639dfe',
    Blue65: '#468BFE',
    Blue60: '#2377fd',
    Blue55: '#0766ee', // Main
    Blue50: '#0559d2'
  },
  Neutral: {
    White: '#ffffff',
    P98: '#f7f8fa',
    // Control hover: buttons, chips, pills (ENG-2094). Sits between P98 and P96.
    P97: '#f0f3f7',
    P96: '#eff2f6',
    P94: '#e8ebf1',
    P90: '#d9dee8',
    P85: '#c6cedc',
    P80: '#b4bed0',
    P75: '#a2afc3',
    P70: '#929fb5',
    P60: '#738198',
    P50: '#55647c',
    P40: '#394860',
    P35: '#2e3b51',
    P30: '#252e3d'
  }
}

export type BrandPalette = typeof brandPalette
export type SecondaryPalette = typeof secondaryPalette
export type SemanticPalette = typeof semanticPalette
